import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {AuthMessage} from '../locales';

/**
 * `authenticate` request params
 * (what is used to send to server)
 */
export interface AuthenticateRequestOptions {
	login: string;
	password: string;
}

/**
 * `authenticate` request
 * (what gets sent to the server)
 */
export type AuthenticateRequest = [
	AuthenticateRequestOptions['login'],
	AuthenticateRequestOptions['password'],
];

/**
 * `authenticate` response
 * (what comes back from the server)
 */
export type AuthenticateResponse = SuccessResponse<AuthenticateResult>;

/**
 * `authenticate` result
 * (what is utilized from the server response)
 */
export type AuthenticateResult = string;

export const authenticateEndpoint = 'authenticate';

/**
 * Authenticate user
 * @param fetchParams Fetch params
 * @returns Session key
 */
export const authenticate = async ({
	login,
	password,
}: AuthenticateRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: AuthenticateRequest = [login, password];

	return client
		.post<AuthenticateResponse>(authenticateEndpoint, requestParams)
		.then((response) => {
			if (response.data.result === '-1') {
				throw new Error(AuthMessage.INVALID_LOGIN);
			}
			return response.data.result;
		});
};
export default authenticate;
